import React from 'react';
import { DsExplorerLink, DsIcon, DsTooltip } from '@tokenyico/design-system/dist/reactJS';
import { dateFormat } from '@tokenyico/design-system';
import RedemptionStatusType from './RedemptionStatusType';
import { useTranslation } from 'react-i18next';
import { currencyFormat, datetimeFormat, numberFormat } from '@tokenyico/design-system';
import { formatExchangeRate } from 'app/helpers/currency';
import { Item, Section } from 'app/views/Platform/views/Orders/helpers';
import { connect } from 'redux-zero/react';

const RedemptionOrderDetailsView = ({ order, selectedToken, user }) => {
  const {
    status,
    tokenPrice,
    tokenAmount,
    tokenPriceAt,
    createdAt,
    paymentCurrency,
    exchangeRate,
    totalRedemptionAmount,
    confirmationDate,
    cutOff,
    tradeDate,
  } = order;
  const { t } = useTranslation();

  return (
    <>
      <header>
        <h3>{t('shared.orderDetails')}</h3> <span>{datetimeFormat(createdAt)}</span>
      </header>

      {cutOff && tradeDate ? (
        <div className="calendar _text:xs">
          <div className="row">
            <p className="_text-coolGrey-500">
              {t('shared.cutOffDateTime')}
              <DsTooltip isVisibleOnHover text={t('shared.cutOffTooltip')} className="_mleft-2">
                <DsIcon name="info" size="0.8rem" color="var(--coolGrey-400)" />
              </DsTooltip>
            </p>
            <p className="_text-coolGrey-700">{datetimeFormat(new Date(Date.parse(cutOff)))}</p>
          </div>
          <div className="row">
            <p className="_text-coolGrey-500">
              {t('shared.tradeDate')}
              <DsTooltip isVisibleOnHover text={t('shared.tradeDateTooltip')} className="_mleft-2">
                <DsIcon name="info" size="0.8rem" color="var(--coolGrey-400)" />
              </DsTooltip>
            </p>
            <p className="_text-coolGrey-700">
              {dateFormat(new Date(Date.parse(tradeDate)), true)}
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className="order-details">
        <Section>
          <Item
            name={t('shared.status')}
            value={<RedemptionStatusType status={status} />}
            isMono={false}
          />
          <Item
            name={t('shared.investorWallet')}
            value={
              <DsExplorerLink
                address={user.walletsAndStatus[0].wallet}
                network={selectedToken.blockchainNetwork}
                type="wallet"
                width="160"
              />
            }
            isMono={false}
          />

          <Item
            name={t('shared.tokenPrice')}
            value={
              ['CANCELED_BY_INVESTOR', 'CANCELED_BY_ISSUER'].includes(status) ? (
                '-'
              ) : tokenPrice ? (
                currencyFormat(tokenPrice, selectedToken.currency, true)
              ) : (
                <DsTooltip
                  theme="light"
                  isVisibleOnHover={true}
                  text={t('shared.tokenPriceSetByIssuer')}
                >
                  <DsIcon name="help" iconSize="14px" color="var(--warning)" />
                </DsTooltip>
              )
            }
          />
          <Item
            name={t('shared.tokenPriceTime')}
            value={
              ['CANCELED_BY_INVESTOR', 'CANCELED_BY_ISSUER'].includes(status) ? (
                '-'
              ) : tokenPriceAt ? (
                datetimeFormat(tokenPriceAt)
              ) : (
                <DsIcon name="pending" iconSize="14px" color="var(--warning)" />
              )
            }
            isMono={!tokenPrice}
          />
        </Section>

        <Section>
          <Item
            name={t('shared.tokensToRedeem')}
            //tokens to redeem
            value={
              tokenAmount
                ? `${numberFormat(tokenAmount, selectedToken.decimals)} ${selectedToken.symbol}`
                : '-'
            }
          />

          <Item
            name={t('shared.exchangeRate')}
            value={
              exchangeRate
                ? formatExchangeRate(exchangeRate, selectedToken.currency, paymentCurrency)
                : '-'
            }
          />

          <Item
            name={t('shared.amountToReceive')}
            value={
              ['CANCELED_BY_INVESTOR', 'CANCELED_BY_ISSUER'].includes(status) ? (
                '-'
              ) : totalRedemptionAmount ? (
                currencyFormat(totalRedemptionAmount, paymentCurrency, true)
              ) : (
                <DsTooltip theme="light" isVisibleOnHover={true} text={t('shared.amountToPayNull')}>
                  <DsIcon name="help" iconSize="14px" color="var(--warning)" />
                </DsTooltip>
              )
            }
          />
          <Item
            name={t('shared.paymentSentDate')}
            value={confirmationDate ? datetimeFormat(confirmationDate) : '-'}
            isMono={false}
          />
        </Section>
      </div>
    </>
  );
};
const mapToProps = (state) => state.holder;

export default connect(mapToProps)(RedemptionOrderDetailsView);
